export default {
  title: 'Pedidos',
  number: 'Pedido {id}',
  denied_title: 'Sem permissão para ver pedidos',
  denied_hint: 'Fale com o administrador da sua conta.',
  empty: 'Nenhum pedido ainda.',
}
